import { APIAdminOrganizationAttributes } from '@ardoq/api-types';
import { ArdoqError } from '@ardoq/common-helpers';
import { actionCreator } from '@ardoq/rxbeach';

export const fetchCurrentOrganizationRequested = actionCreator(
  '[organizations] FETCH_CURRENT'
);

export const fetchCurrentOrganizationSucceeded =
  actionCreator<APIAdminOrganizationAttributes>(
    '[organizations] FETCH_CURRENT_SUCCEEDED'
  );

export const updateOrganizationRequested =
  actionCreator<APIAdminOrganizationAttributes>('[organizations] UPDATE');

export const updateOrganizationSucceeded =
  actionCreator<APIAdminOrganizationAttributes>(
    '[organizations] UPDATE_SUCCEEDED'
  );

export const updateOrganizationFailed = actionCreator<ArdoqError>(
  '[organizations] UPDATE_FAILED'
);
